<template>
  <div class="mt_7 content_box">
    <title-box text="产品介绍"></title-box>
    <p class="desc">
      {{ showDesc }}
    </p>
    <div
      v-for="(item, index) in showProductList"
      :key="index"
      class="product_item d_flex justify_content_center"
      :class="index % 2 !== 0 ? 'flex_row_reverse even' : ''"
      @click="productItemClick(item)"
    >
      <img :src="item.listSrc" alt="" srcset="" />
      <div style="width: 537px;padding-top:80px">
        <h4>{{ item.id }}</h4>
        <p
          v-for="(item, index) in item.contentArr"
          :key="index"
          class="content_item"
        >
          {{ item }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import TitleBox from "@/components/title.vue";
import { productList, productTypeList } from "@/utils/const.js";
export default {
  name: "Product",
  components: {
    TitleBox
  },
  props: ["type", "desc"],
  data() {
    return {};
  },
  computed: {
    showProductList() {
      let arr = [];
      if (this.type === "college") {
        arr = productTypeList[3].children.slice(0, 3);
      } else if (this.type === "convenience") {
        arr = productTypeList[4].children;
      } else if (this.type === "box") {
        arr = productTypeList[6].children;
      }
      return arr.map(item => {
        return productList.find(productItem => productItem.id === item);
      });
    },
    showDesc() {
      return (
        this.desc ||
        "自主研发设计的一款智能安全打印服务器终端，适配多种市场主流打印机型号。多拉宝盒特点是：尺寸更小，功能更强大，微电子工艺技术，即插即用等诸多优点."
      );
    }
  },
  methods: {
    productItemClick(item) {
      this.$router.push("/product/detail?id=" + item.id);
    }
  }
};
</script>

<style scoped lang="scss">
.desc {
  width: 831px;
  font-size: 16px;
  color: #888888;
  line-height: 30px;
  margin: 25px auto 0;
  text-align: center;
}

.product_item {
  padding-top: 70px;
  cursor: pointer;
  img {
    margin-right: 100px;
  }
  h4 {
    font-size: 34px;
    font-weight: 600;
    color: #323232;
    border-bottom: 6px solid #fde101;
    width: fit-content;
    margin-bottom: 30px;
  }
  .content_item {
    font-size: 16px;
    font-weight: 500;
    color: #323232;
    line-height: 40px;
  }
}

.even img {
  margin-right: 0;
  margin-left: 100px;
}
</style>
